import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { PRODUCTS } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';
import { useState } from 'react';

export const ProductLines = () => {
  const [ref, inView] = useInView({ threshold: 0.05 });
  const [activeProduct, setActiveProduct] = useState(null);

  return (
    <section id="products" ref={ref} className="relative py-28 bg-[#0D1B2A] overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-20 left-10 w-80 h-80 bg-[#D4952B]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#147DAB]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <span className="text-[#E8B84A] text-sm font-semibold tracking-[0.2em] uppercase">What We Build</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3 leading-tight">
            Product Lines
          </h2>
          <p className="text-2xl md:text-3xl text-white/25 font-semibold mt-2 font-['Noto_Sans_Arabic']">خطوط الإنتاج</p>
          <p className="text-white/40 mt-4 max-w-xl text-base leading-relaxed">
            Six comprehensive product lines engineered for the Arabian climate, powering everything from giga-projects to remote villages.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PRODUCTS.map((product, i) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.15 + i * 0.08 }}
              className="group relative bg-white/[0.03] border border-white/8 rounded-2xl overflow-hidden hover:border-[#D4952B]/30 transition-all duration-500 hover:bg-white/[0.06] cursor-pointer"
              onMouseEnter={() => setActiveProduct(product.id)}
              onMouseLeave={() => setActiveProduct(null)}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-[#0D1B2A]/30 to-transparent" />
                {/* Tag */}
                <div className="absolute bottom-4 left-4">
                  <span className="px-3 py-1 bg-[#D4952B]/90 text-white text-[10px] font-bold tracking-wider uppercase rounded-md">
                    SGFS
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-white mb-1 group-hover:text-[#E8B84A] transition-colors duration-300">
                  {product.title}
                </h3>
                <p className="text-white/25 text-xs font-medium mb-3" dir="rtl">{product.titleAr}</p>
                <p className="text-white/45 text-sm leading-relaxed line-clamp-3">
                  {product.description}
                </p>
                <div className="mt-5 flex items-center gap-2 text-[#E8B84A] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span>Learn More</span>
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
